import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  background-color: red;
`;

export const ProfessionalWrapper = styled.div`
  margin-bottom: 20px;
`;

export const PreferScheduleContainer = styled.div`
  h1 {
    font-weight: 600;
    font-size: 24px;
    margin: 10px 5px;
  }
`;

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
`;

export const CardContainer = styled.div`
  box-sizing: border-box;
  background-color: white;
  margin-top: 15px;
  padding: 10px;
  height: 70px;
  border: 1px solid #d5d5d6;
  width: 100%;
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    color: #555658;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
`;

export const ContainerIcon = styled.div`
  text-align: left;
`;

export const TitleCalendarSchedule = styled.div`
  display: flex;
  align-items: center;

  img {
    display: inline-block;
    height: 20px;
    width: 20px;
  }

  p {
    font-size: 14px;
    display: inline-block;
    margin-left: 10px;
  }
`;

export const TitleCalendar = styled.p`
  font-weight: 500;
  text-align: left;
  color: #898b8e;

  font-size: 14px;
`;

export const ContainerBlDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: center;
  margin-top: 20px;
`;

interface BlDateProps {
  active: boolean;
}

export const BlDate = styled.div<BlDateProps>`
  border: ${props => (props.active ? '0' : '1px solid #ccc')};
  border-radius: 8px;

  /* width: 100%; */
  width: 72px;
  height: 72px;
  margin: 2px;
  & + & {
    margin-left: 12px;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: ${props => (props.active ? '#004F92' : 'transparent')};

  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const TitleNumber = styled.span<BlDateProps>`
  font-size: 28px;
  font-weight: 600;
  color: ${props => (props.active ? '#FFFFFF' : '#555658')};
  width: 100%;
`;

export const DescDate = styled.span<BlDateProps>`
  font-size: 12px;
  color: ${props => (props.active ? '#FFFFFF' : '#898b8e')};
  width: 100%;
`;

export const IconPlusCircle = styled.p`
  font-size: 7px;
  color: #898b8e;
  width: 100%;
`;

export const BodyWrapper = styled.div`
  padding-bottom: 110px;
`;

export const TitleContainer = styled.div`
  display: none;

  @media (min-width: 900px) {
    display: block;
  }
`;

export const SpecialistCardWrapper = styled.div``;
